import { z } from "zod";

export const autoDispatchGlobalAccessorialsSchema = z.object({
	id: z.number(),
	description: z.string(),
});

export const globalCarrierSchema = z.object({
	capacityProviderId: z.string(),
	carrierId: z.number(),
	carrierName: z.string().nullable(),
	isEligibleForAPIDispatch: z.boolean(),
	isActiveForAPIDispatch: z.boolean(),
	isEligibleForAPITracking: z.boolean(),
	isActiveForTracking: z.boolean(),
	isPickupOnlyDispatch: z.boolean(),
	canAutoDispatch: z.boolean(),
	dispatchTime: z.string().nullable(),
	dispatchDaysInAdvance: z.number().nullable(),
	accessorials: z.array(autoDispatchGlobalAccessorialsSchema).nullable(),
});

export const selectedGlobalCarriersSchema = z.object({
	carrierId: z.number(),
	scac: z.string(),
	carrierName: z.string(),
	canAutoDispatch: z.boolean(),
	dispatchTime: z.string().nullable(),
	dispatchDaysInAdvance: z.number().nullable(),
	customerCarriers: z.array(z.unknown()),
	carrierAccessorials: z.array(z.unknown()),
});

export const patchGlobalCarrierSchema = z.object({
	carrierId: z.number(),
	canAutoDispatch: z.boolean(),
	dispatchTime: z.string().nullable(),
	dispatchDaysInAdvance: z.number().nullable(),
	accessorialIds: z.array(z.number()),
});

export const customerCarrierSchema = z.object({
	canAutoDispatch: z.boolean(),
	carrierId: z.number(),
	carrierName: z.string(),
	customerId: z.number(),
	scac: z.string(),
});

export const enabledCustomerCarrierSchema = z.object({
	customerId: z.number(),
	carrierId: z.number(),
	scac: z.string(),
	carrierName: z.string(),
	isEnabledOnCarrierLevel: z.boolean(),
	isEnabledForCustomer: z.boolean(),
	disabledDateUTC: z.string().nullable(),
	disabledByUserId: z.number().nullable(),
});

export const disabledCustomerCarrierSchema = z.object({
	customerID: z.number(),
	carrierID: z.number(),
	disabledDateUTC: z.string().nullable(),
	disabledByUserId: z.number().nullable(),
	scac: z.string(),
	carrierName: z.string(),
});

export const disableCustomerCarrierRequestSchema = z.object({
	customerID: z.number(),
	carrierID: z.number(),
	disabledDateUTC: z.string().nullable().optional(),
	disabledByUserId: z.number().nullable().optional(),
});

export const disabledCustomerTenderUserSchema = z.object({
	customerID: z.number(),
	tenderUserTypeID: z.number().int().min(1).max(3),
	tenderUserTypeName: z.string(),
	disabledDateUTC: z.string().nullable(),
	disabledByUserId: z.number().nullable(),
});

export const disableCustomerTenderUserRequestSchema = z.object({
	customerID: z.number(),
	tenderUserTypeID: z.number().int().min(1).max(3),
	disabledDateUTC: z.string().nullable().optional(),
	disabledByUserId: z.number().nullable().optional(),
});

export const selectedCustomerTenderSettingsSchema = z.object({
	customerId: z.number(),
	canDispatchOnCustomerTender: z.boolean(),
	canDispatchOnTQLTender: z.boolean(),
	canDispatchOnVendorTender: z.boolean(),
});

export const autoDispatchGlobalAccessorialsSchemaArray = z.array(
	autoDispatchGlobalAccessorialsSchema,
);

export type AutoDispatchGlobalAccessorial = z.infer<
	typeof autoDispatchGlobalAccessorialsSchema
>;
export type AutoDispatchGlobalAccessorials = z.infer<
	typeof autoDispatchGlobalAccessorialsSchemaArray
>;

export type GlobalCarrier = z.infer<typeof globalCarrierSchema>;
export type SelectedGlobalCarrier = z.infer<
	typeof selectedGlobalCarriersSchema
>;

export type CustomerCarrier = z.infer<typeof customerCarrierSchema>;

export type EnabledCustomerCarrier = z.infer<
	typeof enabledCustomerCarrierSchema
>;

export type DisabledCustomerCarrier = z.infer<
	typeof disabledCustomerCarrierSchema
>;

export type DisableCustomerCarrierRequest = z.infer<
	typeof disableCustomerCarrierRequestSchema
>;

export type DisabledCustomerTenderUser = z.infer<
	typeof disabledCustomerTenderUserSchema
>;

export type DisableCustomerTenderUserRequest = z.infer<
	typeof disableCustomerTenderUserRequestSchema
>;

export type CustomerTenderSettings = z.infer<
	typeof selectedCustomerTenderSettingsSchema
>;
